export function getValueByPath(obj: any, path: string) {
  if (!path.includes('.')) {
    return obj[path];
  }
  return path.split('.').reduce((acc, key) => {
    return acc ? acc[key] : undefined;
  }, obj);
}
